// DashboardLayout pages
import Primary from "./Primary.vue";
import ShiftsCalendar from "./Shifts/Calendar.vue";
import ShiftsReport from "./Shifts/ShiftsReport.vue";
import ShiftsHealthProfessionals from "./Shifts/HealthProfessionals.vue";
import ShiftsNewHealthProfessionals from "./Shifts/NewHealthProfessionals.vue";
import AdminUsers from "./Admin/Users.vue";
import AdminUnitManagers from "./Admin/UnitManagers.vue";
import AdminUnits from "./Admin/Units.vue";
import AdminInhouseProfessionals from "./Admin/InhouseProfessionals.vue";
import AdminServices from "./Admin/Services.vue";
import AdminShiftKinds from "./Admin/ShiftKinds.vue";
import FinanceAccountsPayable from "./Finance/AccountsPayable";
import FinanceAccountsReceivable from "./Finance/AccountsReceivable";
import FinancePayroll from "./Finance/Payroll";
import FinanceLumpSumPayments from "./Finance/LumpSumPayments";
import FinanceBankingFiles from "./Finance/BankingFiles";
import ReportWeekdayWeekend from "./Reports/WeekdayWeekendReport.vue";
import ShiftsPerSpecialtyReport from './Reports/ShiftsPerSpecialtyReport'
import LumpSumPaymentsReport from './Reports/LumpSumPaymentsReport.vue';
import DashboardSettings from "./Settings/DashboardSettings.vue";
import TotalHoursValueReport from './Reports/TotalHoursValueReport'
import CNESReport from './Reports/CNESReport'
import ValidatedShiftsReport from './Reports/ValidatedShiftsReport'
import AccountabilityReport from './Reports/AccountabilityReport'
import AnalyticalTransferReport from './Reports/AnalyticalTransferReport'

export default {
	ShiftsCalendar,
	ShiftsReport,
	ShiftsHealthProfessionals,
	ShiftsNewHealthProfessionals,
	Primary,
	AdminUsers,
	AdminUnitManagers,
	AdminUnits,
	AdminInhouseProfessionals,
	AdminServices,
	AdminShiftKinds,
	FinanceAccountsPayable,
	FinanceAccountsReceivable,
	FinancePayroll,
	FinanceLumpSumPayments,
	FinanceBankingFiles,
	ReportWeekdayWeekend,
	DashboardSettings,
	ShiftsPerSpecialtyReport,
	TotalHoursValueReport,
	LumpSumPaymentsReport,
	CNESReport,
	ValidatedShiftsReport,
	AccountabilityReport,
	AnalyticalTransferReport
};
